import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeDir1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3,
    handleClickSel4, handleClickSel5, handleClickSel6, handleClickSel7, handleClickSel8,
    handleClickSel9, handleClickSel10}) => {
  const a010501 = autorizacUA.findIndex( autorizac => autorizac === "010501" );
  const a010505 = autorizacUA.findIndex( autorizac => autorizac === "010505" );
  const a010510 = autorizacUA.findIndex( autorizac => autorizac === "010510" );
  const a010515 = autorizacUA.findIndex( autorizac => autorizac === "010515" );
  const a010520 = autorizacUA.findIndex( autorizac => autorizac === "010520" );
  const a010525 = autorizacUA.findIndex( autorizac => autorizac === "010525" );
  const a010530 = autorizacUA.findIndex( autorizac => autorizac === "010530" );
  const a010535 = autorizacUA.findIndex( autorizac => autorizac === "010535" );
  const a010540 = autorizacUA.findIndex( autorizac => autorizac === "010540" );
  const a010550 = autorizacUA.findIndex( autorizac => autorizac === "010550" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a010501!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large square outline violet icon"></i>
        Departamentos
      </button>
      }
      {a010505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large columns violet icon"></i>
        Ciudades
      </button>
      }
      {a010510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large table violet icon"></i>
        Zonas
      </button>
      }
      {a010515!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large chess board violet icon"></i>
        Barrios
      </button>
      }

      {(a010520!==-1||a010525!==-1) &&
      <Divider inverted />
      }

      {a010520!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
        <i className="large building violet icon"></i>
        Tipos de unidad matriz
        </button>
      }
      {a010525!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel6}>
        <i className="large building outline violet icon"></i>
        Unidades matriz
        </button>
      }

      {(a010530!==-1||a010535!==-1) &&
      <Divider inverted />
      }

      {a010530!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel7}>
        <i className="large home violet icon"></i>
        Tipos de unidad
        </button>
      }
      {a010535!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel8}>
        <i className="large compress violet icon"></i>
        Tipos de vía
      </button>
      }

      {a010540!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel9}>
            <i className="large ordered list violet icon"></i>
            Estratos
          </button>
        </div>
      }

      {a010550!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel10}>
            <i className="large ordered list violet icon"></i>
            Nodos
          </button>
        </div>
      }      
    </div>
  )
};

export default HomeDir1
